export default __webpack_public_path__ + "static/media/Copy of 20-Update-Your-Handbook.0dd9331d.jpg";